<template>
  <div class="tab-content">
    <div class="block-1">
      <div class="row item-center">
        <div class="row item-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="19"
            viewBox="0 0 15 19"
            fill="none"
          >
            <path
              d="M1 12.8334V6.16675C1 3.80972 1 2.63121 1.73223 1.89898C2.46447 1.16675 3.64297 1.16675 6 1.16675H9.47633C9.81692 1.16675 9.98725 1.16675 10.1404 1.23018C10.2935 1.29361 10.414 1.41405 10.6548 1.65491L13.8452 4.84526C14.086 5.08611 14.2065 5.20655 14.2699 5.35969C14.3333 5.51283 14.3333 5.68315 14.3333 6.02377V12.8334C14.3333 15.1904 14.3333 16.3689 13.6011 17.1012C12.8688 17.8334 11.6903 17.8334 9.33333 17.8334H6C3.64297 17.8334 2.46447 17.8334 1.73223 17.1012C1 16.3689 1 15.1904 1 12.8334Z"
              stroke="#93AFC8"
              stroke-width="1.3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p class="count-url">{{ meta.totalEntries }} {{ $t('WEB_SOURCES.WEB_DETAIL.TAB_NAME.URL') }}</p>
        </div>
        
        <p v-if="uiFlags.stepGenerate === 1" class="text-border text-border-loading text-truncate">
          <fluent-icon icon="checkmark-circle" size="14" />
          {{ $t('WEB_SOURCES.WEB_DETAIL.TAB_URLS.STATUS_1') }}
        </p>
        <p v-else-if="uiFlags.stepGenerate === 2" class="text-border text-border-success text-truncate">
          <fluent-icon icon="checkmark" size="14" />
          {{ $t('WEB_SOURCES.WEB_DETAIL.TAB_URLS.STATUS_2') }}
        </p>
        <p v-else class="text-truncate">
          {{ $t('WEB_SOURCES.WEB_DETAIL.TAB_URLS.STATUS_0') }}
        </p>
      </div>
      <woot-button v-if="uiFlags.stepGenerate === 0 && webUrlList.length > 0" @click="approveAndGenerate">
        {{ $t('WEB_SOURCES.WEB_DETAIL.TAB_URLS.APPROVED_BUTTON.BUTTON_TEXT') }}
      </woot-button>
    </div>
    <div class="block-3">
      <section class="webs-table-wrap">
        <ve-table
          :fixed-header="false"
          :columns="columns"
          :table-data="webUrlList"
          class="bg-light"
          :checkbox-option="checkboxOption"
          row-key-field-name="id"
        />
        <woot-loading-state
          v-if="uiFlags.isFetching"
          :message="$t('WEB_PAGE_SOURCES.TABLE.LOADING')"
        />
        <div
          v-else-if="!uiFlags.isFetching && meta.totalEntries === 0"
          class="webs--empty-records"
        >
          <spinner />
          <span>{{ $t("WEB_PAGE_SOURCES.TABLE.EMPTY_STATE") }}</span>
        </div>

        <table-footer
          :current-page="Number(meta.currentPage)"
          :total-count="meta.totalEntries"
          :page-size="meta.perPage"
          @page-change="onPageChange"
        />
      </section>
    </div>
    <woot-delete-modal
      :show.sync="showDeletePopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="$t('WEB_PAGE_SOURCES.ACTIONS.DELETE.CONFIRM.TITLE')"
      :message="$t('WEB_PAGE_SOURCES.ACTIONS.DELETE.CONFIRM.MESSAGE')"
      :confirm-text="$t('WEB_PAGE_SOURCES.ACTIONS.DELETE.CONFIRM.YES')"
      :reject-text="$t('WEB_PAGE_SOURCES.ACTIONS.DELETE.CONFIRM.NO')"
    />
  </div>
</template>

<script>
import globalConfigMixin from 'shared/mixins/globalConfigMixin';
import alertMixin from 'shared/mixins/alertMixin';
import { VeTable } from "vue-easytable";
import { mapGetters } from "vuex";
import Spinner from "shared/components/Spinner.vue";
import { formatDateString } from "shared/helpers/DateHelper";
import Switch from "dashboard/components/ui/Switch.vue";
import TableFooter from 'dashboard/components/widgets/TableFooter';

export default {
  components: {
    Spinner,
    VeTable,
    Switch,
    TableFooter,
  },
  mixins: [globalConfigMixin, alertMixin],
  props: {
    webs: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      showDeletePopup: false,
      currentUrl: {},
      selectedRows: [],
      checkboxOption: {
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.selectRows(selectedRowKeys);
        },
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.selectRows(selectedRowKeys);
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      webUrlList: "webs/getWebUrls",
      uiFlags: "webs/getUIFlags",
      meta: 'webs/getWebUrlsMeta',
    }),
    columns() {
      return [
        {
          key: "check",
          type: "checkbox",
          title: "",
          width: 30,
          align: "center",
        },
        {
          field: "title",
          key: "title",
          title: this.$t("WEB_SOURCES.WEB_DETAIL.TABLE_HEAD.TITLE_URL"),
          fixed: "left",
          width: 250,
          align: this.isRTLView ? "right" : "left",
          renderBodyCell: ({ row }) => {
            return (
              <div class="text-truncate">
                <a href={row.url} target="_blank">{row.url}</a>
              </div>
            );
          },
        },
        {
          field: "updated_at",
          key: "updated",
          title: this.$t("WEB_SOURCES.WEB_DETAIL.TABLE_HEAD.LAST_EDITED"),
          align: this.isRTLView ? "right" : "left",
          width: 80,
          renderBodyCell: ({ row }) => {
            return <span>{formatDateString(row.updated_at)}</span>;
          },
        },
        {
          field: "actions",
          key: "actions",
          title: "",
          align: this.isRTLView ? "right" : "left",
          width: 50,
          renderBodyCell: ({ row }) => {
            return (
              <div class="button-wrapper">
                <woot-button
                  v-tooltip={this.$t("WEB_SOURCES.ACTIONS.DELETE.BUTTON_TEXT")}
                  variant="smooth"
                  size="tiny"
                  color-scheme="alert"
                  class-names="grey-btn"
                  icon="dismiss-circle"
                  onClick={() => this.openDeletePopup(row)}
                />
              </div>
            );
          },
        },
      ];
    },
  },
  mounted() {
    this.fetchWebUrls();
  },
  methods: {
    onPageChange(page) {
      this.fetchWebUrls(page);
    },
    updatePageParam(page) {
      window.history.pushState({}, null, `${this.$route.path}?page=${page}`);
    },
    selectRows(data) {
      this.selectedRows = data;
      this.$emit('selectrows', data);
    },
    fetchWebUrls(page) {
      this.updatePageParam(page);

      const { webId } = this.$route.params;

      const requestParams = {
        websiteId: webId,
        page: page,
        perPage: this.meta.perPage,
        sortBy: this.meta.sortBy,
        sortOrder: this.meta.sortOrder,
      };

      this.$store.dispatch('webs/getWebUrls', requestParams)
    },
    openDeletePopup(url) {
      this.currentUrl = url;
      this.showDeletePopup = true;
    },
    closeDeletePopup() {
      this.currentUrl = {};
      this.showDeletePopup = false;
    },
    async confirmDeletion () {
      const { webId } = this.$route.params;
      await this.$store.dispatch('webs/deleteWebUrl', { website_id: webId, website_page_id: this.currentUrl.id })
      this.closeDeletePopup();
      this.showAlert(this.$t('WEB_PAGE_SOURCES.ACTIONS.DELETE.API.SUCCESS_MESSAGE'));
    },
    async approveAndGenerate() {
      const { webId } = this.$route.params;

      await this.$store.dispatch('webs/generateQuestions', { website_id: webId })
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~dashboard/assets/scss/mixins";
@import '~widget/assets/scss/variables';

.tab-content {
  padding: $space-normal;
  background: var(--s-25);
  height: 100%;
  .block-1 {
    border-radius: 0.6rem;
    border: 1px solid var(--s-100);
    background: $color-white;
    display: flex;
    justify-content: space-between;
    padding: 1.8rem $space-two;
    align-items: center;
    margin-bottom: $space-two;
    p {
      margin-bottom: 0;
    }
    .count-url {
      padding-left: $space-two;
      padding-right: 16px;
      border-right: 1px solid var(--s-100);
      font-weight: 600;
      line-height: 0;
    }
    .text-border {
      font-size: 14px;
      text-transform: unset;
      padding-left: 16px;
      display: flex;
      align-items: center;
      gap: 6px;
      font-weight: 500;
    }
    .text-border-loading {
      color: var(--w-500);
    }
    .text-border-success {
      color: #30B537;
    }
    svg {
      font-weight: 900;
    }
  }
  .block-2 {
    .search-input {
      position: relative;
    }
    .search-icon {
      position: absolute;
      left: 1.25rem;
      top: 50%;
      transform: translateY(-50%);
    }
    input {
      padding-left: 45px;
      border-radius: 5px;
      background: #f1f5f8;
      color: var(--color-body);
      font-size: 12px;
      font-weight: 600;
      border: none;
    }
  }
}
.webs-table-wrap {
  flex: 1 1;
  height: 100%;
}

.webs-table-wrap::v-deep {
  .ve-table {
    padding-top: var(--space-two);
  }
  .ve-table-container {
    overflow-y: initial;
    border: 0 !important;
  }

  .ve-table-header-th {
    padding: var(--space-small) var(--space-two) !important;
  }

  .ve-table-body {
    overflow: auto;
  }
  .ve-table-body-tr {
    border-bottom: 0 !important;
  }

  .ve-table-body-td {
    padding: var(--space-small) var(--space-two) !important;
    background-color: var(--s-25) !important;
    vertical-align: top;
    border: 0 !important;
  }

  .ve-table-header-th {
    font-size: var(--font-size-mini) !important;
    background-color: var(--s-25) !important;
    vertical-align: top;
  }
}

.webs--empty-records {
  align-items: center;
  background-color: var(--white);
  border: 1px solid var(--color-border);
  border-top: 0;
  display: flex;
  font-size: var(--font-size-mini);
  height: 7rem;
  justify-content: center;
  margin-top: -1px;
  width: 100%;
}

.web-left-wrap {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  margin-left: var(--space-large);
  margin-right: var(--space-large);
}

.item-center {
  align-items: center;
}
.btn-indicator {
  background-color: unset !important;
}
.btn-indicator:hover,
.btn-indicator:focus {
  background-color: unset !important;
}
a {
  text-decoration-line: underline;
  font-size: 14px;
  color: var(--color-body);
  line-height: 1.5rem;
}
.state-status {
  display: flex;
  gap: 0.8rem;
}
.button.grey-btn {
  margin-left: 0;
}
.status-label {
  padding: 3px 10px;
  border-radius: 4px;
  background: var(--s-100);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.8rem;
  color: $color-body;
}
.label-completed {
  background: #d7f4d8;
  color: #30b537;
}
</style>
